/** Converte valor digitado em reais (1.500,00) para centavos inteiros. */
export function reaisInputToCents(amount: string): number | null {
  const trimmed = amount.trim();
  if (!trimmed) return null;
  if (!/^(?:\d{1,3}(?:\.\d{3})*|\d+)(?:,\d{1,2})?$/.test(trimmed)) return null;
  const value = Number(trimmed.replace(/\./g, '').replace(',', '.'));
  if (!Number.isFinite(value) || value < 0) return null;
  return Math.round(value * 100);
}

export function isStaleInvoiceRequest(seq: number, latest: number): boolean {
  return seq !== latest;
}

/** Página a carregar quando a atual ficou vazia. null mantém a página. */
export function pageAfterEmptyInvoiceResult(
  page: number,
  itemCount: number,
  totalPages: number,
): number | null {
  if (itemCount > 0 || page <= 1) return null;
  const next = totalPages > 0 ? Math.min(page, totalPages) : 1;
  return next === page ? page - 1 : next;
}
